var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScanqrIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7V4C1 3.20435 1.31607 2.44129 1.87868 1.87868C2.44129 1.31607 3.20435 1 4 1H7M1 19V22C1 22.7956 1.31607 23.5587 1.87868 24.1213C2.44129 24.6839 3.20435 25 4 25H7M19 1H22C22.7956 1 23.5587 1.31607 24.1213 1.87868C24.6839 2.44129 25 3.20435 25 4V7M19 25H22C22.7956 25 23.5587 24.6839 24.1213 24.1213C24.6839 23.5587 25 22.7956 25 22V19M5.5 13H20.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanqrIcon);
export default __webpack_public_path__ + "static/media/scanqr-icon.b5f0634f5328da4b419aa328e853828d.svg";
export { ForwardRef as ReactComponent };